import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a64f8e2c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a64f8e2c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f8e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a64f8e2c')) {
      api.createRecord('a64f8e2c', component.options)
    } else {
      api.reload('a64f8e2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a64f8e2c&scoped=true", function () {
      api.rerender('a64f8e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/auction/placeBid/detail/index.vue"
export default component.exports